/* ab-n-series-product-selections.js
USED BY: ab-n-series-options.liquid
(ab-n-wire-codes.js is also in that liquid file and holds the wire codes dictionary called: wcDictionary)

PURPOSE: shows additional n series selections and options to create a variation of the product.

NOTE: product part number is set in the ab-n-series-options.liquid file and used here in js
productPartNum - mfg part #
*/


let wireCode = "AA";
let wireSizeCheck = "";
let wireSpecCheck = "";

const typeSelector = document.querySelector('#select-code');
const wireCodeSelector = document.querySelector('#wire-code-selection');
const wireCodeSelectorGroup = document.querySelector('#wire-code-group');
wireCodeSelectorGroup.hidden = true;
const wireSpecSelector = document.querySelector('#wire-spec');
const wireSpecSelectorGroup = document.querySelector('#wire-spec-group');
wireSpecSelectorGroup.hidden = true;
const wireSizeSelector = document.querySelector('#wire-size');
const wireSizeSelectorGroup = document.querySelector('#wire-size-group');
wireSizeSelectorGroup.hidden = true;
const wireColorSelector = document.querySelector('#wire-color');
const wireColorSelectorGroup = document.querySelector('#wire-color-group');
wireColorSelectorGroup.hidden = true;
const wireLengthSelector = document.querySelector('#wire-length');
const wireLengthSelectorGroup = document.querySelector('#wire-length-group');
wireLengthSelectorGroup.hidden = true;


// add event listener for wire code input selector selection
if (typeSelector != null){
  typeSelector.addEventListener('change', function (){
    //reset the wire code value
    wireCode='';
  
    // if user knows their desired wire code, let them select it
    if (typeSelector.value == 'YES'){
      wireCodeSelectorGroup.hidden = false;
      wireSpecSelectorGroup.hidden = true;
      wireSizeSelectorGroup.hidden = true;
      wireColorSelectorGroup.hidden = true;
      wireLengthSelectorGroup.hidden = true;
    // otherwise, help user select building blocks to make the wire code
    } else if (typeSelector.value =='NO'){
      wireCodeSelector.value = getWireCode();
      // hide the wire codes list
      wireCodeSelectorGroup.hidden = true;
      // show the specification selector
      wireSpecSelectorGroup.hidden = false;
    }
    updateVariantName(); 
   });
}
// add event listener for wire code input selector selection
if (wireCodeSelector != null){
  wireCodeSelector.addEventListener('change', function (){
    if (typeSelector.value == 'YES'){
      wireCode = wireCodeSelector.value;
      setWireFields(wireCode);
      updateVariantName(); 
    }
  })
}


// add event listener for wire spec input selector selection
if (wireSpecSelector != null){
  wireSpecSelector.addEventListener('change', function (){
    if (wireSpecSelector.value == 'BLANK'){
      wireSizeSelectorGroup.hidden = true;
      wireColorSelectorGroup.hidden = true;
      wireLengthSelectorGroup.hidden = true;    
    } else {
      wireSizeSelectorGroup.hidden = false;
      wireColorSelectorGroup.hidden = true;
      wireLengthSelectorGroup.hidden = true; 
    }
    // updated wire size & color menus based on spec slection
    updateWireSizeMenu();
    updateWireColorMenu();
    wireCode = getWireCode(wireSpecSelector.value, wireSizeSelector.value, wireColorSelector.value, wireLengthSelector.value);
    updateVariantName();
  })
}

// add event listener for wire size input selector selection
if (wireSizeSelector != null){
  wireSizeSelector.addEventListener('change', function (){
    if (wireSizeSelector.value == 'BLANK'){
      wireColorSelectorGroup.hidden = true;
      wireLengthSelectorGroup.hidden = true;  
    } else {
      wireColorSelectorGroup.hidden = false;
      wireLengthSelectorGroup.hidden = true; 
    }
    wireCode = getWireCode(wireSpecSelector.value, wireSizeSelector.value, wireColorSelector.value, wireLengthSelector.value);
    updateVariantName();
  })
}

// add event listener for wire color input selector selection
if (wireColorSelector != null){
  wireColorSelector.addEventListener('change', function (){
    if (wireColorSelector.value == 'BLANK'){
      wireLengthSelectorGroup.hidden = true; 
    } else {
      wireLengthSelectorGroup.hidden = false;    
    }
    wireCode = getWireCode(wireSpecSelector.value, wireSizeSelector.value, wireColorSelector.value, wireLengthSelector.value);
    // set the wire code list value to match the new wire code.  This shows it nicely when adding to the cart.
    wireCodeSelector.value = wireCode;
    updateVariantName();
  })
}

// add event listener for wire length input selector selection
if (wireLengthSelector != null){
  wireLengthSelector.addEventListener('change', function (){
    if (wireLengthSelector.value != 'BLANK'){
      wireCode = getWireCode(wireSpecSelector.value, wireSizeSelector.value, wireColorSelector.value, wireLengthSelector.value);
      updateVariantName();
    }
  })
}

function updateWireSizeMenu(){
  if (wireSpecSelector.value == 'NEMA'){
    wireSizeSelector.innerHTML = '<option value="BLANK"> --Please choose a wire size-- </option><option value="30"> 30 AWG</option><option value="32"> 32 AWG</option>';
  } else {
    wireSizeSelector.innerHTML = '<option value="BLANK"> --Please choose a wire size-- </option><option value="30"> 30 AWG</option>';
  }
}

function updateWireColorMenu(){
  if (wireSpecSelector.value == 'NEMA'){
    wireColorSelector.innerHTML = '<option value="BLANK"> --Please choose a color-- </option><option value="COLOR"> Color Coded (solid colors)</option><option value="WHITE"> White</option><option value="YELLOW"> Yellow</option>';
  } else {
    wireColorSelector.innerHTML = '<option value="BLANK"> --Please choose a color-- </option><option value="COLOR"> Color Coded (solid colors)</option><option value="WHITE"> White</option>';
  }
}

let newPartNumName = "";
// update variant name based on options that are selected
function updateVariantName(){
  let newPartNumName = "";
  // adjust for when part number series designator is NMSP vs NM
  let offset = 0;
  if (seriesDesignator.length == 4){
    offset = 2;
  } else {
    offset = 0;
  }
  // get the part number up to the wire code
  let wireCodePartNumPrefix = productPartNum.slice(0,17+offset);
  // check for options code
  let optionsVal = "";
  if (productPartNum.length > (19+offset)){
    optionsVal = productPartNum.slice(-3);
  }
   newPartNumName = wireCodePartNumPrefix + wireCode + optionsVal;

  const variantNameContainer = document.querySelector('#variant-name');
 // if (newPartNumName != '' && wireCode != 'AA'){
  if (wireCode != 'AA' && wireCode !='BLANK' && wireCode !=''){
    variantNameContainer.innerHTML = '<div>Selected wire code: ' + wireCode + '</div><div><h6> <div class="variant-name" id="variant-name"></div>Variant Part #: ' + newPartNumName + '</h6> (' + productPartNum + ') </div>';
    const variantName = document.querySelector('#variant-part-num');
    variantName.value = newPartNumName;
  
  } else {
    variantNameContainer.innerHTML = '';
  }

}


function getWireCode(wcSpec, wcSize, wcColor, wcLength){
  if(wcSpec !='BLANK' && wcSize != 'BLANK' && wcColor !='BLANK' && wcLength !='BLANK'){
    let wcColorCheck = "";
    let wcSpecCheck = "";
    let wcSizeCheck = "";
    let wcLengthCheck = "";
    
    
    for(const eachGroup in wcDictionary){
      let wcSpecCheck = wcDictionary[eachGroup]["wcSpecMenu"];
      let wcSizeCheck = wcDictionary[eachGroup]["wcWireSizeMenu"];
      let wcColorCheck = wcDictionary[eachGroup]["wcColorMenu"];
      let wcLengthCheck = wcDictionary[eachGroup]["wcLengthMenu"];
      //console.log(wcSpecCheck + ", " + wcSizeCheck + ", " + wcColorCheck + ", " + wcLengthCheck);

      if(wcSpecCheck == wcSpec && wcSizeCheck == wcSize && wcColorCheck == wcColor && wcLengthCheck == wcLength){
        console.log("*****  MATCH FOUND  ******  CODE: " + wcDictionary[eachGroup]["wireCode"]);
        wireCodeSelector.value = wcDictionary[eachGroup]["wireCode"];
        return wcDictionary[eachGroup]["wireCode"];
      }
    }
  } else {
    return 'BLANK';
  }
}

// set the values for color, spec, size, and length inputs when user is directly selecting the wire code input 
function setWireFields(wireCode) {
    if (wireCode != 'BLANK') {
        let wireCodeCheck = "";
        let wcColor = "";
        let wcSpec = "";
        let wcSize = "";
        let wcLength = "";

        for (const eachGroup in wcDictionary) {
            let wireCodeCheck = wcDictionary[eachGroup]["wireCode"];
            if (wireCodeCheck == wireCode) {
                console.log("*****  MATCH FOUND  ******  CODE: " + wcDictionary[eachGroup]["wireCode"]);
                wireCodeSelector.value = wcDictionary[eachGroup]["wireCode"];
                wcSpec = wcDictionary[eachGroup]["wcSpecMenu"];
                wcSize = wcDictionary[eachGroup]["wcWireSizeMenu"];
                wcColor = wcDictionary[eachGroup]["wcColorMenu"];
                wcLength = wcDictionary[eachGroup]["wcLengthMenu"];

              wireSpecSelector.value = wcSpec;
              wireSizeSelector.value = wcSize;
              wireColorSelector.value = wcColor;
              wireLengthSelector.value = wcLength;                  
              return wcDictionary[eachGroup]["wireCode"];
            }
        }
    } else {
        return 'BLANK';
    }
}


const wcDictionary = {
  
"AA": {
    "wireCode": "AA",
    "wcDesc": "30 AWG, NEMA HP3, Color Coded, Length: 6",
    "wcMenuDesc": " AA (Size: 30AWG, Spec: NEMA HP3,Color: Color Coded, Length: 6.0\")",
    "wcSpec": "NEMA HP3",
    "wcSpecDesc": "NEMA HP3",
    "wcSpecMenu": "NEMA",
    "wcWireSize": "30 AWG",
    "wcWireSizeDesc": "30 AWG",
    "wcWireSizeMenu": "30",
    "wcColor": "Color Coded",
    "wcColorDesc": "Color coding in accordance with MIL-STD-681, System I, except using ten solid colors only in repeating sequence.",
    "wcColorMenu": "COLOR",
    "wcLength": "6.0\"",
    "wcLengthDesc": "6.0\" (+1.0\"/-0.0\")",
    "wcLengthMenu": "6"
},
"AB": {
    "wireCode": "AB",
    "wcDesc": "30 AWG, NEMA HP3, Color Coded, Length:12\"",
    "wcMenuDesc": " AB (Size: 30AWG, Spec: NEMA HP3,Color: Color Coded, Length: 12.0\")",
    "wcSpec": "NEMA HP3",
    "wcSpecDesc": "NEMA HP3",
    "wcSpecMenu": "NEMA",
    "wcWireSize": "30 AWG",
    "wcWireSizeDesc": "30 AWG",
    "wcWireSizeMenu": "30",
    "wcColor": "Color Coded",
    "wcColorDesc": "Color coding in accordance with MIL-STD-681, System I, except using ten solid colors only in repeating sequence.",
    "wcColorMenu": "COLOR",
    "wcLength": "12.0\"",
    "wcLengthDesc": "12.0\" (+1.0\"/-0.0\")",
    "wcLengthMenu": "12"
},
"AC": {
    "wireCode": "AC",
    "wcDesc": "30 AWG, NEMA HP3, Color Coded, Length: 18\"",
    "wcMenuDesc": " AC (Size: 30AWG, Spec: NEMA HP3,Color: Color Coded, Length: 18.0\")",
    "wcSpec": "NEMA HP3",
    "wcSpecDesc": "NEMA HP3",
    "wcSpecMenu": "NEMA",
    "wcWireSize": "30 AWG",
    "wcWireSizeDesc": "30 AWG",
    "wcWireSizeMenu": "30",
    "wcColor": "Color Coded",
    "wcColorDesc": "Color coding in accordance with MIL-STD-681, System I, except using ten solid colors only in repeating sequence.",
    "wcColorMenu": "COLOR",
    "wcLength": "18.0\"",
    "wcLengthDesc": "18.0\" (+1.0\"/-0.0\")",
    "wcLengthMenu": "18"
},
"AD": {
    "wireCode": "AD",
    "wcDesc": "30 AWG, NEMA HP3, Color Coded, Length: 36\"",
    "wcMenuDesc": " AD (Size: 30AWG, Spec: NEMA HP3,Color: Color Coded, Length: 36.0\")",
    "wcSpec": "NEMA HP3",
    "wcSpecDesc": "NEMA HP3",
    "wcSpecMenu": "NEMA",
    "wcWireSize": "30 AWG",
    "cWireSizeDesc": "30 AWG",
    "wcWireSizeMenu": "30",
    "wcColor": "Color Coded",
    "wcColorDesc": "Color coding in accordance with MIL-STD-681, System I, except using ten solid colors only in repeating sequence.",
    "wcColorMenu": "COLOR",
    "wcLength": "36.0\"",
    "wcLengthDesc": "36.0\" (+1.0\"/-0.0\")",
    "wcLengthMenu": "36"
},
"AE": {
    "wireCode": "AE",
    "wcDesc": "30 AWG, NEMA HP3, White, Length: 6\"",
    "wcMenuDesc": " AE (Size: 30AWG, Spec: NEMA HP3,Color: White, Length: 6.0\")",
    "wcSpec": "NEMA HP3",
    "wcSpecDesc": "NEMA HP3",
    "wcSpecMenu": "NEMA",
    "wcWireSize": "30 AWG",
    "wcWireSizeDesc": "30 AWG",
    "wcWireSizeMenu": "30",
    "wcColor": "White",
    "wcColorDesc": "White",
    "wcColorMenu": "WHITE",
    "wcLength": "6.0\"",
    "wcLengthMenu": "6"
},
"AF": {
    "wireCode": "AF",
    "wcDesc": "30 AWG, NEMA HP3, White, Length:12\"",
    "wcMenuDesc": " AF (Size: 30AWG, Spec: NEMA HP3,Color: White, Length: 12.0\")",
    "wcSpec": "NEMA HP3",
    "wcSpecDesc": "NEMA HP3",
    "wcSpecMenu": "NEMA",
    "wcWireSize": "30 AWG",
    "wcWireSizeDesc": "30 AWG",
    "wcWireSizeMenu": "30",
    "wcColor": "White",
    "wcColorDesc": "White",
    "wcColorMenu": "WHITE",
    "wcLength": "12.0\"",
    "wcLengthDesc": "12.0\" (+1.0\"/-0.0\")",
    "wcLengthMenu": "12"
},
"AG": {
    "wireCode": "AG",
    "wcDesc": "30 AWG, NEMA HP3, White, Length: 18\"",
    "wcMenuDesc": " AG (Size: 30AWG, Spec: NEMA HP3,Color: White, Length: 18.0\")",
    "wcSpec": "NEMA HP3",
    "wcSpecDesc": "NEMA HP3",
    "wcSpecMenu": "NEMA",
    "wcWireSize": "30 AWG",
    "wcWireSizeDesc": "30 AWG",
    "wcWireSizeMenu": "30",
    "wcColor": "White",
    "wcColorDesc": "White",
    "wcColorMenu": "WHITE",
    "wcLength": "18.0\"",
    "wcLengthDesc": "18.0\" (+1.0\"/-0.0\")",
    "wcLengthMenu": "18"
},
"AH": {
    "wireCode": "AH",
    "wcDesc": "30 AWG, NEMA HP3, White, Length: 36\"",
    "wcMenuDesc": " AH (Size: 30AWG, Spec: NEMA HP3,Color: White, Length: 36.0\")",
    "wcSpec": "NEMA HP3",
    "wcSpecDesc": "NEMA HP3",
    "wcSpecMenu": "NEMA",
    "wcWireSize": "30 AWG",
    "wcWireSizeDesc": "30 AWG",
    "wcWireSizeMenu": "30",
    "wcColor": "White",
    "wcColorDesc": "White",
    "wcColorMenu": "WHITE",
    "wcLength": "36.0\"",
    "wcLengthDesc": "36.0\" (+1.0\"/-0.0\")",
    "wcLengthMenu": "36"
},
"AJ": {
    "wireCode": "AJ",
    "wcDesc": "30 AWG, NEMA HP3, Yellow, Length: 6\"",
    "wcMenuDesc": " AJ (Size: 30AWG, Spec: NEMA HP3,Color: Yellow, Length: 6.0\")",
    "wcSpec": "NEMA HP3",
    "wcSpecDesc": "NEMA HP3",
    "wcSpecMenu": "NEMA",
    "wcWireSize": "30 AWG",
    "wcWireSizeDesc": "30 AWG",
    "wcWireSizeMenu": "30",
    "wcColor": "Yellow",
    "wcColorDesc": "Yellow",
    "wcColorMenu": "YELLOW",
    "wcLength": "6.0\"",
    "wcLengthDesc": "6.0\" (+1.0\"/-0.0\")",
    "wcLengthMenu": "6"
},
"AK": {
    "wireCode": "AK",
    "wcDesc": "30 AWG, NEMA HP3, Yellow, Length:12\"",
    "wcMenuDesc": " AK (Size: 30AWG, Spec: NEMA HP3,Color: Yellow, Length: 12.0\")",
    "wcSpec": "NEMA HP3",
    "wcSpecDesc": "NEMA HP3",
    "wcSpecMenu": "NEMA",
    "wcWireSize": "30 AWG",
    "wcWireSizeDesc": "30 AWG",
    "wcWireSizeMenu": "30",
    "wcColor": "Yellow",
    "wcColorDesc": "Yellow",
    "wcColorMenu": "YELLOW",
    "wcLength": "12.0\"",
    "wcLengthDesc": "12.0\" (+1.0\"/-0.0\")",
    "wcLengthMenu": "12"
},
"AL": {
    "wireCode": "AL",
    "wcDesc": "30 AWG, NEMA HP3, Yellow, Length: 18\"",
    "wcMenuDesc": " AL (Size: 30AWG, Spec: NEMA HP3,Color: Yellow, Length: 18.0\")",
    "wcSpec": "NEMA HP3",
    "wcSpecDesc": "NEMA HP3",
    "wcSpecMenu": "NEMA",
    "wcWireSize": "30 AWG",
    "wcWireSizeDesc": "30 AWG",
    "wcWireSizeMenu": "30",
    "wcColor": "Yellow",
    "wcColorDesc": "Yellow",
    "wcColorMenu": "YELLOW",
    "wcLength": "18.0\"",
    "wcLengthDesc": "18.0\" (+1.0\"/-0.0\")",
    "wcLengthMenu": "18"
},
"AM": {
    "wireCode": "AM",
    "wcDesc": "30 AWG, NEMA HP3, Yellow, Length: 36\"",
    "wcMenuDesc": " AM (Size: 30AWG, Spec: NEMA HP3,Color: Yellow, Length: 36.0\")",
    "wcSpec": "NEMA HP3",
    "wcSpecDesc": "NEMA HP3",
    "wcSpecMenu": "NEMA",
    "wcWireSize": "30 AWG",
    "wcWireSizeDesc": "30 AWG",
    "wcWireSizeMenu": "30",
    "wcColor": "Yellow",
    "wcColorDesc": "Yellow",
    "wcColorMenu": "YELLOW",
    "wcLength": "36.0\"",
    "wcLengthDesc": "36.0\" (+1.0\"/-0.0\")",
    "wcLengthMenu": "36"
},
"AN": {
    "wireCode": "AN",
    "wcDesc": "32 AWG, NEMA HP3, Color Coded, Length: 6\"",
    "wcMenuDesc": " AN (Size: 32AWG, Spec: NEMA HP3,Color: Color Coded, Length: 6.0\")",
    "wcSpec": "NEMA HP3",
    "wcSpecDesc": "NEMA HP3",
    "wcSpecMenu": "NEMA",
    "wcWireSize": "32 AWG",
    "wcWireSizeDesc": "32 AWG",
    "wcWireSizeMenu": "32",
    "wcColor": "Color Coded",
    "wcColorDesc": "Color coding in accordance with MIL-STD-681, System I, except using ten solid colors only in repeating sequence.",
    "wcColorMenu": "COLOR",
    "wcLength": "6.0\"",
    "wcLengthDesc": "6.0\" (+1.0\"/-0.0\")",
    "wcLengthMenu": "6"
},
"AP": {
    "wireCode": "AP",
    "wcDesc": "32 AWG, NEMA HP3, Color Coded, Length:12\"",
    "wcMenuDesc": " AP (Size: 32AWG, Spec: NEMA HP3,Color: Color Coded, Length: 12.0\")",
    "wcSpec": "NEMA HP3",
    "wcSpecDesc": "NEMA HP3",
    "wcSpecMenu": "NEMA",
    "wcWireSize": "32 AWG",
    "wcWireSizeDesc": "32 AWG",
    "wcWireSizeMenu": "32",
    "wcColor": "Color Coded",
    "wcColorDesc": "Color coding in accordance with MIL-STD-681, System I, except using ten solid colors only in repeating sequence.",
    "wcColorMenu": "COLOR",
    "wcLength": "12.0\"",
    "wcLengthDesc": "12.0\" (+1.0\"/-0.0\")",
    "wcLengthMenu": "12"
},
"AQ": {
    "wireCode": "AQ",
    "wcDesc": "32 AWG, NEMA HP3, Color Coded, Length: 18\"",
    "wcMenuDesc": " AQ (Size: 32AWG, Spec: NEMA HP3,Color: Color Coded, Length: 18.0\")",
    "wcSpec": "NEMA HP3",
    "wcSpecDesc": "NEMA HP3",
    "wcSpecMenu": "NEMA",
    "wcWireSize": "32 AWG",
    "wcWireSizeDesc": "32 AWG",
    "wcWireSizeMenu": "32",
    "wcColor": "Color Coded",
    "wcColorDesc": "Color coding in accordance with MIL-STD-681, System I, except using ten solid colors only in repeating sequence.",
    "wcColorMenu": "COLOR",
    "wcLength": "18.0\"",
    "wcLengthDesc": "18.0\" (+1.0\"/-0.0\")",
    "wcLengthMenu": "18"
},
"AR": {
    "wireCode": "AR",
    "wcDesc": "32 AWG, NEMA HP3, Color Coded, Length: 36\"",
    "wcMenuDesc": " AR (Size: 32AWG, Spec: NEMA HP3,Color: Color Coded, Length: 36.0\")",
    "wcSpec": "NEMA HP3",
    "wcSpecDesc": "NEMA HP3",
    "wcSpecMenu": "NEMA",
    "wcWireSize": "32 AWG",
    "wcWireSizeDesc": "32 AWG",
    "wcWireSizeMenu": "32",
    "wcColor": "Color Coded",
    "wcColorDesc": "Color coding in accordance with MIL-STD-681, System I, except using ten solid colors only in repeating sequence.",
    "wcColorMenu": "COLOR",
    "wcLength": "36.0\"",
    "wcLengthDesc": "36.0\" (+1.0\"/-0.0\")",
    "wcLengthMenu": "36"
},
"AS": {
    "wireCode": "AS",
    "wcDesc": "32 AWG, NEMA HP3, White, Length: 6\"",
    "wcMenuDesc": " AS (Size: 32AWG, Spec: NEMA HP3,Color: White, Length: 6.0\")",
    "wcSpec": "NEMA HP3",
    "wcSpecDesc": "NEMA HP3",
    "wcSpecMenu": "NEMA",
    "wcWireSize": "32 AWG",
    "wcWireSizeDesc": "32 AWG",
    "wcWireSizeMenu": "32",
    "wcColor": "White",
    "wcColorDesc": "White",
    "wcColorMenu": "WHITE",
    "wcLength": "6.0\"",
    "wcLengthDesc": "6.0\" (+1.0\"/-0.0\")",
    "wcLengthMenu": "6"
},
"AT": {
    "wireCode": "AT",
    "wcDesc": "32 AWG, NEMA HP3, White, Length:12\"",
    "wcMenuDesc": " AT (Size: 32AWG, Spec: NEMA HP3,Color: White, Length: 12.0\")",
    "wcSpec": "NEMA HP3",
    "wcSpecDesc": "NEMA HP3",
    "wcSpecMenu": "NEMA",
    "wcWireSize": "32 AWG",
    "wcWireSizeDesc": "32 AWG",
    "wcWireSizeMenu": "32",
    "wcColor": "White",
    "wcColorDesc": "White",
    "wcColorMenu": "WHITE",
    "wcLength": "12.0\"",
    "wcLengthDesc": "12.0\" (+1.0\"/-0.0\")",
    "wcLengthMenu": "12"
},
"AU": {
    "wireCode": "AU",
    "wcDesc": "32 AWG, NEMA HP3, White, Length: 18\"",
    "wcMenuDesc": " AU (Size: 32AWG, Spec: NEMA HP3,Color: White, Length: 18.0\")",
    "wcSpec": "NEMA HP3",
    "wcSpecDesc": "NEMA HP3",
    "wcSpecMenu": "NEMA",
    "wcWireSize": "32 AWG",
    "wcWireSizeDesc": "32 AWG",
    "wcWireSizeMenu": "32",
    "wcColor": "White",
    "wcColorDesc": "White",
    "wcColorMenu": "WHITE",
    "wcLength": "18.0\"",
    "wcLengthDesc": "18.0\" (+1.0\"/-0.0\")",
    "wcLengthMenu": "18"
},
"AV": {
    "wireCode": "AV",
    "wcDesc": "32 AWG, NEMA HP3, White, Length: 36\"",
    "wcMenuDesc": " AV (Size: 32AWG, Spec: NEMA HP3,Color: White, Length: 36.0\")",
    "wcSpec": "NEMA HP3",
    "wcSpecDesc": "NEMA HP3",
    "wcSpecMenu": "NEMA",
    "wcWireSize": "32 AWG",
    "wcWireSizeDesc": "32 AWG",
    "wcWireSizeMenu": "32",
    "wcColor": "White",
    "wcColorDesc": "White",
    "wcColorMenu": "WHITE",
    "wcLength": "36.0\"",
    "wcLengthDesc": "36.0\" (+1.0\"/-0.0\")",
    "wcLengthMenu": "36"
},
"AW": {
    "wireCode": "AW",
    "wcDesc": "32 AWG, NEMA HP3, Yellow, Length: 6\"",
    "wcMenuDesc": " AW (Size: 32AWG, Spec: NEMA HP3,Color: Yellow, Length: 6.0\")",
    "wcSpec": "NEMA HP3",
    "wcSpecDesc": "NEMA HP3",
    "wcSpecMenu": "NEMA",
    "wcWireSize": "32 AWG",
    "wcWireSizeDesc": "32 AWG",
    "wcWireSizeMenu": "32",
    "wcColor": "Yellow",
    "wcColorDesc": "Yellow",
    "wcColorMenu": "YELLOW",
    "wcLength": "6.0\"",
    "wcLengthDesc": "6.0\" (+1.0\"/-0.0\")",
    "wcLengthMenu": "6"
},
"AX": {
    "wireCode": "AX",
    "wcDesc": "32 AWG, NEMA HP3, Yellow, Length:12\"",
    "wcMenuDesc": " AX (Size: 32AWG, Spec: NEMA HP3,Color: Yellow, Length: 12.0\")",
    "wcSpec": "NEMA HP3",
    "wcSpecDesc": "NEMA HP3",
    "wcSpecMenu": "NEMA",
    "wcWireSize": "32 AWG",
    "wcWireSizeDesc": "32 AWG",
    "wcWireSizeMenu": "32",
    "wcColor": "Yellow",
    "wcColorDesc": "Yellow",
    "wcColorMenu": "YELLOW",
    "wcLength": "12.0\"",
    "wcLengthDesc": "12.0\" (+1.0\"/-0.0\")",
    "wcLengthMenu": "12"
},
"AY": {
    "wireCode": "AY",
    "wcDesc": "32 AWG, NEMA HP3, Yellow, Length: 18\"",
    "wcMenuDesc": " AY (Size: 32AWG, Spec: NEMA HP3,Color: Yellow, Length: 18.0\")",
    "wcSpec": "NEMA HP3",
    "wcSpecDesc": "NEMA HP3",
    "wcSpecMenu": "NEMA",
    "wcWireSize": "32 AWG",
    "wcWireSizeDesc": "32 AWG",
    "wcWireSizeMenu": "32",
    "wcColor": "Yellow",
    "wcColorDesc": "Yellow",
    "wcColorMenu": "YELLOW",
    "wcLength": "18.0\"",
    "wcLengthDesc": "18.0\" (+1.0\"/-0.0\")",
    "wcLengthMenu": "18"
},
"AZ": {
    "wireCode": "AZ",
    "wcDesc": "32 AWG, NEMA HP3, Yellow, Length: 36\"",
    "wcMenuDesc": " AZ (Size: 32AWG, Spec: NEMA HP3,Color: Yellow, Length: 36.0\")",
    "wcSpec": "NEMA HP3",
    "wcSpecDesc": "NEMA HP3",
    "wcSpecMenu": "NEMA",
    "wcWireSize": "32 AWG",
    "wcWireSizeDesc": "32 AWG",
    "wcWireSizeMenu": "32",
    "wcColor": "Yellow",
    "wcColorDesc": "Yellow",
    "wcColorMenu": "YELLOW",
    "wcLength": "36.0\"",
    "wcLengthDesc": "36.0\" (+1.0\"/-0.0\")",
    "wcLengthMenu": "36"
},
"BA": {
    "wireCode": "BA",
    "wcDesc": "30 AWG, SAE-AS22759/33, Color Coded, Length: 6\"",
    "wcMenuDesc": " BA (Size: 30AWG, Spec: SAE-AS22759/33,Color: Color Coded, Length: 6.0\")",
    "wcSpec": "SAE-AS22759/33",
    "wcSpecDesc": "SAE-AS22759/33",
    "wcSpecMenu": "SAE",
    "wcWireSize": "30 AWG",
    "wcWireSizeDesc": "30 AWG",
    "wcWireSizeMenu": "30",
    "wcColor": "Color Coded",
    "wcColorDesc": "Color coding in accordance with MIL-STD-681, System I, except using ten solid colors only in repeating sequence.",
    "wcColorMenu": "COLOR",
    "wcLength": "6.0\"",
    "wcLengthDesc": "6.0\" (+1.0\"/-0.0\")",
    "wcLengthMenu": "6"
},
"BB": {
    "wireCode": "BB",
    "wcDesc": "30 AWG, SAE-AS22759/33, Color Coded, Length:12\"",
    "wcMenuDesc": " BB (Size: 30AWG, Spec: SAE-AS22759/33,Color: Color Coded, Length: 12.0\")",
    "wcSpec": "SAE-AS22759/33",
    "wcSpecDesc": "SAE-AS22759/33",
    "wcSpecMenu": "SAE",
    "wcWireSize": "30 AWG",
    "wcWireSizeDesc": "30 AWG",
    "wcWireSizeMenu": "30",
    "wcColor": "Color Coded",
    "wcColorDesc": "Color coding in accordance with MIL-STD-681, System I, except using ten solid colors only in repeating sequence.",
    "wcColorMenu": "COLOR",
    "wcLength": "12.0\"",
    "wcLengthDesc": "12.0\" (+1.0\"/-0.0\")",
    "wcLengthMenu": "12"
},
"BC": {
    "wireCode": "BC",
    "wcDesc": "30 AWG, SAE-AS22759/33, Color Coded, Length: 18\"",
    "wcMenuDesc": " BC (Size: 30AWG, Spec: SAE-AS22759/33,Color: Color Coded, Length: 18.0\")",
    "wcSpec": "SAE-AS22759/33",
    "wcSpecDesc": "SAE-AS22759/33",
    "wcSpecMenu": "SAE",
    "wcWireSize": "30 AWG",
    "wcWireSizeDesc": "30 AWG",
    "wcWireSizeMenu": "30",
    "wcColor": "Color Coded",
    "wcColorDesc": "Color coding in accordance with MIL-STD-681, System I, except using ten solid colors only in repeating sequence.",
    "wcColorMenu": "COLOR",
    "wcLength": "18.0\"",
    "wcLengthDesc": "18.0\" (+1.0\"/-0.0\")",
    "wcLengthMenu": "18"
},
"BD": {
    "wireCode": "BD",
    "wcDesc": "30 AWG, SAE-AS22759/33, Color Coded, Length: 36\"",
    "wcMenuDesc": " BD (Size: 30AWG, Spec: SAE-AS22759/33,Color: Color Coded, Length: 36.0\")",
    "wcSpec": "SAE-AS22759/33",
    "wcSpecDesc": "SAE-AS22759/33",
    "wcSpecMenu": "SAE",
    "wcWireSize": "30 AWG",
    "wcWireSizeDesc": "30 AWG",
    "wcWireSizeMenu": "30",
    "wcColor": "Color Coded",
    "wcColorDesc": "Color coding in accordance with MIL-STD-681, System I, except using ten solid colors only in repeating sequence.",
    "wcColorMenu": "COLOR",
    "wcLength": "36.0\"",
    "wcLengthDesc": "36.0\" (+1.0\"/-0.0\")",
    "wcLengthMenu": "36"
},
"BE": {
    "wireCode": "BE",
    "wcDesc": "30 AWG, SAE-AS22759/33, White, Length: 6\"",
    "wcMenuDesc": " BE (Size: 30AWG, Spec: SAE-AS22759/33,Color: White, Length: 6.0\")",
    "wcSpec": "SAE-AS22759/33",
    "wcSpecDesc": "SAE-AS22759/33",
    "wcSpecMenu": "SAE",
    "wcWireSize": "30 AWG",
    "wcWireSizeDesc": "30 AWG",
    "wcWireSizeMenu": "30",
    "wcColor": "White",
    "wcColorDesc": "White",
    "wcColorMenu": "WHITE",
    "wcLength": "6.0\"",
    "wcLengthDesc": "6.0\" (+1.0\"/-0.0\")",
    "wcLengthMenu": "6"
},
"BF": {
    "wireCode": "BF",
    "wcDesc": "30 AWG, SAE-AS22759/33, White, Length:12\"",
    "wcMenuDesc": " BF (Size: 30AWG, Spec: SAE-AS22759/33,Color: White, Length: 12.0\")",
    "wcSpec": "SAE-AS22759/33",
    "wcSpecDesc": "SAE-AS22759/33",
    "wcSpecMenu": "SAE",
    "wcWireSize": "30 AWG",
    "wcWireSizeDesc": "30 AWG",
    "wcWireSizeMenu": "30",
    "wcColor": "White",
    "wcColorDesc": "White",
    "wcColorMenu": "WHITE",
    "wcLength": "12.0\"",
    "wcLengthDesc": "12.0\" (+1.0\"/-0.0\")",
    "wcLengthMenu": "12"
},
"BG": {
    "wireCode": "BG",
    "wcDesc": "30 AWG, SAE-AS22759/33, White, Length: 18\"",
    "wcMenuDesc": " BG (Size: 30AWG, Spec: SAE-AS22759/33,Color: White, Length: 18.0\")",
    "wcSpec": "SAE-AS22759/33",
    "wcSpecDesc": "SAE-AS22759/33",
    "wcSpecMenu": "SAE",
    "wcWireSize": "30 AWG",
    "wcWireSizeDesc": "30 AWG",
    "wcWireSizeMenu": "30",
    "wcColor": "White",
    "wcColorDesc": "White",
    "wcColorMenu": "WHITE",
    "wcLength": "18.0\"",
    "wcLengthDesc": "18.0\" (+1.0\"/-0.0\")",
    "wcLengthMenu": "18"
},
"BH": {
    "wireCode": "BH",
    "wcDesc": "30 AWG, SAE-AS22759/33, White, Length: 36\"",
    "wcMenuDesc": " BH (Size: 30AWG, Spec: SAE-AS22759/33,Color: White, Length: 36.0\")",
    "wcSpec": "SAE-AS22759/33",
    "wcSpecDesc": "SAE-AS22759/33",
    "wcSpecMenu": "SAE",
    "wcWireSize": "30 AWG",
    "wcWireSizeDesc": "30 AWG",
    "wcWireSizeMenu": "30",
    "wcColor": "White",
    "wcColorDesc": "White",
    "wcColorMenu": "WHITE",
    "wcLength": "36.0\"",
    "wcLengthDesc": "36.0\" (+1.0\"/-0.0\")",
    "wcLengthMenu": "36"
},
"CA": {
    "wireCode": "CA",
    "wcDesc": "30 AWG, 04047-30A, Color Coded, Length: 6\"",
    "wcMenuDesc": " CA (Size: 30AWG, Spec: 04047-30A (Not RoHS compliant),Color: Color Coded, Length: 6.0\")",
    "wcSpec": "04047-30A",
    "wcSpecDesc": "04047-30A (Not RoHS Compliant)",
    "wcSpecMenu": "04047",
    "wcWireSize": "30 AWG",
    "wcWireSizeDesc": "30 AWG",
    "wcWireSizeMenu": "30",
    "wcColor": "Color Coded",
    "wcColorDesc": "Color coding in accordance with MIL-STD-681, System I, except using ten solid colors only in repeating sequence.",
    "wcColorMenu": "COLOR",
    "wcLength": "6.0\"",
    "wcLengthDesc": "6.0\" (+1.0\"/-0.0\")",
    "wcLengthMenu": "6"
},
"CB": {
    "wireCode": "CB",
    "wcDesc": "30 AWG, 04047-30A, Color Coded, Length:12\"",
    "wcMenuDesc": " CB (Size: 30AWG, Spec: 04047-30A (Not RoHS compliant),Color: Color Coded, Length: 12.0\")",
    "wcSpec": "04047-30A",
    "wcSpecDesc": "04047-30A (Not RoHS Compliant)",
    "wcSpecMenu": "04047",
    "wcWireSize": "30 AWG",
    "wcWireSizeDesc": "30 AWG",
    "wcWireSizeMenu": "30",
    "wcColor": "Color Coded",
    "wcColorDesc": "Color coding in accordance with MIL-STD-681, System I, except using ten solid colors only in repeating sequence.",
    "wcColorMenu": "COLOR",
    "wcLength": "12.0\"",
    "wcLengthDesc": "12.0\" (+1.0\"/-0.0\")",
    "wcLengthMenu": "12"
},
"CC": {
    "wireCode": "CC",
    "wcDesc": "30 AWG, 04047-30A, Color Coded, Length: 18\"",
    "wcMenuDesc": " CC (Size: 30AWG, Spec: 04047-30A (Not RoHS compliant),Color: Color Coded, Length: 18.0\")",
    "wcSpec": "04047-30A",
    "wcSpecDesc": "04047-30A (Not RoHS Compliant)",
    "wcSpecMenu": "04047",
    "wcWireSize": "30 AWG",
    "wcWireSizeDesc": "30 AWG",
    "wcWireSizeMenu": "30",
    "wcColor": "Color Coded",
    "wcColorDesc": "Color coding in accordance with MIL-STD-681, System I, except using ten solid colors only in repeating sequence.",
    "wcColorMenu": "COLOR",
    "wcLength": "18.0\"",
    "wcLengthDesc": "18.0\" (+1.0\"/-0.0\")",
    "wcLengthMenu": "18"
},
"CD": {
    "wireCode": "CD",
    "wcDesc": "30 AWG, 04047-30A, Color Coded, Length: 36\"",
    "wcMenuDesc": " CD (Size: 30AWG, Spec: 04047-30A (Not RoHS compliant),Color: Color Coded, Length: 36.0\")",
    "wcSpec": "04047-30A",
    "wcSpecDesc": "04047-30A (Not RoHS Compliant)",
    "wcSpecMenu": "04047",
    "wcWireSize": "30 AWG",
    "wcWireSizeDesc": "30 AWG",
    "wcWireSizeMenu": "30",
    "wcColor": "Color Coded",
    "wcColorDesc": "Color coding in accordance with MIL-STD-681, System I, except using ten solid colors only in repeating sequence.",
    "wcColorMenu": "COLOR",
    "wcLength": "36.0\"",
    "wcLengthDesc": "36.0\" (+1.0\"/-0.0\")",
    "wcLengthMenu": "36"
},
"CE": {
    "wireCode": "CE",
    "wcDesc": "30 AWG, 04047-30A, White, Length: 6\"",
    "wcMenuDesc": " CE (Size: 30AWG, Spec: 04047-30A (Not RoHS compliant),Color: White, Length: 6.0\")",
    "wcSpec": "04047-30A",
    "wcSpecDesc": "04047-30A (Not RoHS Compliant)",
    "wcSpecMenu": "04047",
    "wcWireSize": "30 AWG",
    "wcWireSizeDesc": "30 AWG",
    "wcWireSizeMenu": "30",
    "wcColor": "White",
    "wcColorDesc": "White",
    "wcColorMenu": "WHITE",
    "wcLength": "6.0\"",
    "wcLengthDesc": "6.0\" (+1.0\"/-0.0\")",
    "wcLengthMenu": "6"
},
"CF": {
    "wireCode": "CF",
    "wcDesc": "30 AWG, 04047-30A, White, Length:12\"",
    "wcMenuDesc": " CF (Size: 30AWG, Spec: 04047-30A (Not RoHS compliant),Color: White, Length: 12.0\")",
    "wcSpec": "04047-30A",
    "wcSpecDesc": "04047-30A (Not RoHS Compliant)",
    "wcSpecMenu": "04047",
    "wcWireSize": "30 AWG",
    "wcWireSizeDesc": "30 AWG",
    "wcWireSizeMenu": "30",
    "wcColor": "White",
    "wcColorDesc": "White",
    "wcColorMenu": "WHITE",
    "wcLength": "12.0\"",
    "wcLengthDesc": "12.0\" (+1.0\"/-0.0\")",
    "wcLengthMenu": "12"
},
"CG": {
    "wireCode": "CG",
    "wcDesc": "30 AWG, 04047-30A, White, Length: 18\"",
    "wcMenuDesc": " CG (Size: 30AWG, Spec: 04047-30A (Not RoHS compliant),Color: White, Length: 18.0\")",
    "wcSpec": "04047-30A",
    "wcSpecDesc": "04047-30A (Not RoHS Compliant)",
    "wcSpecMenu": "04047",
    "wcWireSize": "30 AWG",
    "wcWireSizeDesc": "30 AWG",
    "wcWireSizeMenu": "30",
    "wcColor": "White",
    "wcColorDesc": "White",
    "wcColorMenu": "WHITE",
    "wcLength": "18.0\"",
    "wcLengthDesc": "18.0\" (+1.0\"/-0.0\")",
    "wcLengthMenu": "18"
},
"CH": {
    "wireCode": "CH",
    "wcDesc": "30 AWG, 04047-30A, White, Length: 36\"",
    "wcMenuDesc": " CH (Size: 30AWG, Spec: 04047-30A (Not RoHS compliant),Color: White, Length: 36.0\")",
    "wcSpec": "04047-30A",
    "wcSpecDesc": "04047-30A (Not RoHS Compliant)",
    "wcSpecMenu": "04047",
    "wcWireSize": "30 AWG",
    "wcWireSizeDesc": "30 AWG",
    "wcWireSizeMenu": "30",
    "wcColor": "White",
    "wcColorDesc": "White",
    "wcColorMenu": "WHITE",
    "wcLength": "36.0\"",
    "wcLengthDesc": "36.0\" (+1.0\"/-0.0\")",
    "wcLengthMenu": "36"
}

};





